import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';

interface Props {
  pin: string;
  sampled: boolean;
  onPinChange: (value: string) => void;
  onApprove: () => void;
}

// QC approval of a sampling request: signature PIN + Approve, enabled only after the
// Sampled transfer was recorded.
const RnUzurkuvanjeApproveRow: React.FC<Props> = ({ pin, sampled, onPinChange, onApprove }) => {
  const { t } = useTranslation();
  const title = !sampled
    ? t('rnUzurkuvanjeRequests.approveNeedsSampled')
    : !pin.trim()
      ? t('rnUzurkuvanjeRequests.approveNeedsPin')
      : t('rnUzurkuvanjeRequests.approveWithPin');

  return (
    <>
      <input
        type="password"
        autoComplete="new-password"
        value={pin}
        onChange={(e) => onPinChange(e.target.value)}
        placeholder={t('rnUzurkuvanjeRequests.signaturePin') || ''}
        className="h-8 w-28 rounded-md border border-gray-300 px-2 text-xs focus:outline-none focus:bg-blue-50 dark:focus:bg-blue-900/30 focus:ring-2 focus:ring-blue-500/50 dark:focus:ring-blue-600/50"
      />
      <span
        className="inline-flex"
        title={title}
      >
        <button
          type="button"
          onClick={onApprove}
          disabled={!sampled || !pin.trim()}
          className="inline-flex items-center gap-1 rounded-md border border-blue-200 bg-white px-3 py-1.5 text-xs font-semibold text-blue-700 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500/50 disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400"
        >
          <CheckCircle2 size={14} />
          {t('rnUzurkuvanjeRequests.approve')}
        </button>
      </span>
    </>
  );
};

export default RnUzurkuvanjeApproveRow;
